<template>
  <div class='group-box' v-if="pink">
    <!-- 拼团成功 -->
    <div v-if="pink.status === 'success'" class="pink-success">
      <div class="members">
        <div class="item active" v-for="(pinkedUser, index) in pink.users" :key="index">
          <img :src="pinkedUser.avatar ? pinkedUser.avatar : require('@/assets/icons/none.png')" />
        </div>
      </div>

      <div v-if="pink.isJoin">
        <div class="title">恭喜！拼团已成功，您可以观看此课程</div>
        <div class="view-btns">
          <div class="view-btn" @click="toView">观看课程</div>
          <div class="view-btn" @click="createPoster">邀请好友，赚奖金</div>
        </div>
        <!-- 奖学金信息 -->
        <div class="bonus-info">
          <span>已得奖学金：¥{{user.totalAmount}}</span>
          <span>已提现：¥{{user.withdrawTotalAmount}}</span>
        </div>

        <FocusTip v-if="!pink.subject.isSingle"/>
      </div>
      <div v-else>
        <div class="title">该课已拼团成功，自己开团试试吧！</div>
        <!-- 购买按钮组 -->
        <div class="normal-btn-box">
          <div class="full" @click="fullBuy">
            <p class="price">￥ {{ pink.subject.fullPrice }}</p>
            <p class="alone_buy_btn">单独全价购</p>
          </div>
          <!-- 课程可拼团则显示拼团按钮 -->
          <div class="group" @click="pinkBuy" v-if="pink.subject.isGroup">
            <p class="price">￥ {{ pink.subject.myCoupon ? pink.subject.myCoupon.coupon.groupPrice : pink.subject.groupPrice }} <span v-if="pink.subject.myCoupon">(已减{{ pink.subject.myCoupon.coupon.offAmount }})</span></p>
            <p><span>发起{{ pink.subject.groupNum || 1 }}人团</span></p>
            <p class="limit">限时抢</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 课程详情 -->
    <SubjectDetail :subject="pink.subject" v-if="pink.subject && !pink.isJoin" />

    <!-- 购买弹窗 -->
    <van-action-sheet v-model="showSheet" class="pay_box" title="课程详情" @close="cancelConfirm()" :close-on-click-overlay="false">
      <div class="shop_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/goods.png')" />
        </div>
        <div class="text fl">课程名称</div>
        <div class="name fr">{{ pink.subject.title }}</div>
      </div>
      <div class="buyway_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/buyway.png')" />
        </div>
        <div class="text fl">购买方式</div>
        <div class="name fr">{{ orderType === 'pink_buy' ? '拼团购买' : '单独全价购' }}</div>
      </div>
      <div class="coupon_tab tab" v-if="orderType === 'pink_buy' && myCoupons.length > 0" @click="showCoupon = !showCoupon">
        <div class="img fl">
          <img :src="require('@/assets/icons/coupon.png')" />
        </div>
        <div class="text fl">优惠券抵扣</div>
        <div class="name fr">-¥ {{currentCoupon.coupon.offAmount}}</div>
        <van-icon name="arrow" />
      </div>
      <div class="coupon_list" v-if="orderType === 'pink_buy' && myCoupons.length > 0" v-show="showCoupon">
        <div class="coupon_item" :class="item.id === currentCoupon.id ? 'active' : ''" v-for="(item, index) in myCoupons" :key="index" @click="selectCoupon(item)">
          <van-icon :name="item.id === currentCoupon.id ? 'passed' : 'circle'" />
          省{{item.coupon.offAmount}}元：{{item.coupon.title}}
        </div>
        <div class="coupon_item" :class="!currentCoupon.id ? 'active' : ''" @click="selectCoupon(false)">
          <van-icon :name="!currentCoupon.id ? 'passed' : 'circle'" />
          不使用优惠券
        </div>
      </div>
      <div class="pay_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/pay.png')" />
        </div>
        <div class="text fl">支付总额</div>
        <div class="name fr"><span>￥</span><span class="num">{{ orderType === 'pink_buy' ? currentCoupon.coupon.groupPrice : pink.subject.fullPrice }}</span></div>
      </div>
      <button class="sure_pay" @click="sendOrder">确定支付</button>
    </van-action-sheet>

    <Poster :show="showPosterPopup" :posterData="posterData" @close="showPosterPopup=false" />
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import SubjectDetail from '@/pages/subject/detail'
import { createOrder, getOrderInfo, getPinkInfoAndUserInfo, getUserCoupons } from './query.gql'
import Poster from '@/components/Poster'
import FocusTip from '@/components/FocusTip'

export default {
  name: 'groupSuccess',
  data() {
    return {
      showPosterPopup: false,
      posterData: null,
      myCoupons: [], // 用户优惠券
      currentCoupon: {},
      showCoupon: false,
      user: '',
      pink: '', // 拼团信息
      showSheet: false, // 显示购买弹框
      orderType: 'full_buy' // 购买方式
    }
  },
  components: {
    SubjectDetail,
    Poster,
    FocusTip
  },
  async mounted() {
    console.log('成功页')
    await this.weixinAuth()
    this.loadData() // 获取拼团信息
  },
  methods: {
    loadData() {
      // 请求数据
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getPinkInfoAndUserInfo,
        variables: {
          id: parseInt(self.$route.params.id)
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.profile
        self.pink = res.data.pink
        self.pink.needNum = self.pink.peopleNum - self.pink.users.length // 计算拼团成功还需人数
        console.log(res)
        self.setShare()
        self.$apollo.query({
          query: getUserCoupons,
          variables: {
            subjectId: self.pink.subject.id
          },
          fetchPolicy: 'no-cache'
        }).then(res1 => {
          self.myCoupons = res1.data.userCoupons
          self.currentCoupon = {
            coupon: {
              offAmount: 0,
              groupPrice: self.pink.subject.groupPrice
            }
          }
          let offAmount = 0
          self.myCoupons.forEach(item => {
            switch (item.coupon.types) {
              case 'money_off':
                item.coupon.offAmount = parseFloat(item.coupon.moneyOffAmount).toFixed(2)
                break
              case 'discount':
                item.coupon.offAmount = (parseFloat(self.pink.subject.groupPrice) * (1 - parseFloat(item.coupon.discount) / 100)).toFixed(2)
                break
            }
            item.coupon.groupPrice = (parseFloat(self.pink.subject.groupPrice) - item.coupon.offAmount).toFixed(2)
            if (parseFloat(item.coupon.offAmount) > offAmount) {
              offAmount = parseFloat(item.coupon.offAmount)
              self.$set(self.pink.subject, 'myCoupon', item)
              self.currentCoupon = item
            }
          })
        }).catch(err => {
          console.error('page：subject/index。请求getUserCoupons报错', err)
        })
        self.$toast.clear()
      }).catch(err => {
        console.error('page：group/success。请求getPinkInfoAndUserInfo报错', err)
        self.$toast.fail('加载数据出错')
      })
    },
    setShare() {
      const self = this
      let title = self.pink.needNum > 0 ? `仅差${self.pink.needNum}人!${self.pink.subject.pinkShareTitle}` : self.pink.subject.pinkShareTitle
      // 设置分享
      self.wechatShare({
        title: title,
        imgUrl: self.pink.subject.smallLogoImg,
        desc: self.pink.subject.pinkShareContent,
        link: `${window.location.origin}/?#/group/${self.pink.id}/share`
      })
    },
    selectCoupon(item) {
      if (item) {
        this.currentCoupon = item
      } else {
        this.currentCoupon = {
          coupon: {
            offAmount: 0,
            groupPrice: this.pink.subject.groupPrice
          }
        }
      }
    },
    // 去观看
    toView() {
      location.href = process.env.BASE_URL + '#/learn?id=' + this.pink.subject.id

      // this.$router.replace({
      //   name: 'learn',
      //   params: { id: this.pink.subject.id }
      // })
    },
    // 单独购买
    fullBuy() {
      this.showSheet = true
      this.orderType = 'full_buy'
    },
    // 拼团购买
    pinkBuy() {
      this.showSheet = true
      this.orderType = 'pink_buy'
    },
    // 取消确认
    cancelConfirm() {
      const self = this
      console.log('showSheet', self.showSheet)
      if (self.showSheet) {
        self.$dialog.confirm({
          message: '确认取消付款？',
          confirmButtonText: '继续支付',
          confirmButtonColor: '#ff4e00',
          cancelButtonText: '取消支付'
        }).then(() => {
          self.showSheet = true
        }).catch(() => {
          this.shopSheet = false
          console.log('TODO: 取消订单')
        })
      }
    },
    // 下单
    sendOrder() {
      const self = this
      if (self.pink.isBuySubject || self.pink.hasOngoingPink) {
        self.$toast.fail('已购买此课程')
        console.log('已购买此课程,不能下单,跳转')
        return
      }
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '提交中'
      })
      // 用户未购买此课程
      let variables = {
        subjectId: self.pink.subject.id,
        types: self.orderType
      }
      if (self.currentCoupon.id) {
        Object.assign(variables, {
          userCouponId: self.currentCoupon.id
        })
      }
      console.log('下单参数', variables)

      self.$apollo.mutate({
        mutation: createOrder,
        variables
      }).then(res => {
        console.log('下单结果', res)
        self.showSheet = false
        let result = res.data.createOrderMutation
        if (result.order.totalFee > 0) {
          self.wechatPay().then(() => {
            wx.chooseWXPay({
              timestamp: result.timeStamp,
              nonceStr: result.nonceStr,
              package: result.package,
              signType: result.signType,
              paySign: result.paySign,
              success() {
                self.$toast.clear()
                self.polling(result.order.tranNo)
              },
              cancel() {
                self.$toast.clear()
                self.$toast('支付已取消')
                // 设置分享
                self.setShare()
              },
              fail() {
                self.$toast.clear()
                self.$toast.fail('支付失败')
                // 设置分享
                self.setShare()
              }
            })
          })
        } else {
          self.$toast.clear()
          self.polling(result.order.tranNo)
        }
      }).catch(err => {
        console.error('page: group/success。请求createOrder报错', err)
        self.$toast.clear()
        self.$toast.fail(err.graphQLErrors[0].message || '下单失败')
      })
    },
    // 轮询
    polling(tranNo) {
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '支付中'
      })
      let pollTimes = self.$consts.POLLING_TIMES || 5 // 默认轮询五次
      let timer = setInterval(() => {
        pollTimes -= 1
        if (pollTimes >= 0) {
          self.$apollo.query({
            query: getOrderInfo,
            variables: { tranNo },
            fetchPolicy: 'no-cache'
          }).then(res => {
            if (res.data.order.status === 'paid') {
              self.$toast.clear()
              clearInterval(timer)
              if (res.data.order.types === 'full_buy') {
                self.$router.replace({
                  name: 'classroom',
                  query: {
                    isSingle: self.pink.subject.isSingle
                  }
                })
              } else {
                self.$router.replace({
                  name: 'groupInvite',
                  params: { id: res.data.order.pink.id }
                })
              }
            }
          }).catch(err => {
            console.error('page: group/success。（轮询）请求getOrderInfo报错', err)
          })
        } else {
          // 超过5次轮询没有结果怎么办？？
          self.$toast.clear()
          // 设置分享
          self.setShare()
        }
      }, self.$consts.POLLING_INTERVAL || 2000)
    },
    createPoster() {
      // 生成海报
      const self = this
      self.posterData = {
        user: {
          avatar: self.user.avatar,
          nickname: self.user.nickname
        },
        posterTplImg: self.pink.subject.posterTplImg,
        wxShareLink: `${window.location.origin}/?#/invite/${self.pink.subject.id}?invitationCode=${self.user.invitationCode}`
      }
      self.showPosterPopup = true
    }
  }
}
</script>
<style lang="scss" scoped>
.group-box {
  .pink-success, .pink-fail, .detail {
    background: #fff;
    padding-bottom: 20px;
    .title {
      font-size: 17.5px;
      color: #333;
      padding: 20px 0 15px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 2px;
      span {
        color: #fa512d;
        font-size: 21px;
        font-weight: bold;
      }
    }
    .count-down {
      font-size: 14px;
      padding-bottom: 17px;
      color: #4d4d4d;
      font-weight: bold;
      text-align: center;
      .van-count-down{
        display: inline;
        .item{
          color: #fff;
          display: inline-block;
          width: 27px;
          height: 27px;
          line-height: 27px;
          box-sizing: border-box;
          text-align: center;
          background-color: #666;
          border-radius: 5px;
        }
        .line{
          margin-left: 5px;
        }
      }
    }
    .members {
      padding-top: 20px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .item {
        width: 50px;
        height: 50px;
        margin-right: 17.5px;
        padding: 2.5px;
        box-sizing: border-box;
        margin-top: 6px;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        &.active {
          background: url('~@/assets/images/groupUserHasPayBg.png') no-repeat center / 100%;
        }
      }
    }

    .poster {
      padding-bottom: 14px;
      text-align: center;
      span {
        border-bottom: 1px solid #ff623b;
        font-size: 12.5px;
        line-height: 17.5px;
        color: #ff623b;
      }
    }
  }

  .invite-btns, .sticky-btns {
    height: 46.5px;
    padding-bottom: 7.5px;
    position: relative;
    .invite {
      font-size: 20px;
      height: 46.5px;
      width: 278px;
      line-height: 46.5px;
      font-weight: bold;
      text-align: center;
      margin: 0 auto;
      border-radius: 25px;
      color: #fff;
      position: absolute;
      left: 50%;
      margin-left: -139px;
      background: linear-gradient(to top, #ff4800,#ff9600);
      box-shadow: 0 0 8px #ff8f00;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-appearance: none;
      animation: pulse 1s infinite;
    }
  }

  .view-btns {
      display: flex;
      color: #fff;
      overflow: hidden;
      box-sizing: border-box;
      .view-btn {
        flex: 1;
        padding: 15px 0;
        background-color: #F09E38;
        text-align: center;
        margin: 0 15px;
        border-radius: 28px;
        &:nth-of-type(2){
          background-color: #E75E3D;
        }
      }
    }

  .invite-alert {
    .title {
      display: flex;
      justify-content: center;
      font-size: 28px;
      line-height: 40px;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      color: #333;
      font-weight: bold;
      margin: 10px 0;
      .line {
        margin: 18px 20px;
        height: 2px;
        width: 50px;
        background: #2d3335;
      }
    }
    .content {
      margin: 0 15px;
      padding: 12px 17px;
      background: #f5f6f9;
      color: #666;
      line-height: 24px;
    }
    .extend {
      display: flex;
      justify-content: center;
      margin: 17px auto;
      img {
        height: 30px;
        display: inline-block;
        vertical-align: bottom;
        pointer-events: none;
      }
      span {
        margin-top: 5px;
        font-size: 18px;
        color: #2d3335;
        font-weight: 550;
      }
    }
  }

  .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    .full {
      flex: 1;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
    }
    .group {
      width: 58%;
      padding: 8px 0;
      background-color: #ff4e00;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      .limit {
        color: #fa512d;
        background-color: #ff0;
        position: absolute;
        width: 120px;
        height: 48px;
        line-height: 80px;
        font-size: 18px;
        top: -15px;
        right: -50px;
        font-weight: bold;
        text-align: center;
        transform: rotate(40deg);
      }
    }
    .price {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .normal-btn-box {
    display: flex;
    color: #fff;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 20px;
    padding-bottom: 20px;
    .full {
      flex: 1;
      padding: 8px 0;
      background-color: #ff7639;
      text-align: center;
      margin: 0 15px;
      border-radius: 28px;
    }
    .group {
      width: 45%;
      background-color: #ff4e00;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      padding: 8px 0;
      margin: 0 15px;
      border-radius: 28px;
      position: relative;
      .limit {
        color: #fa512d;
        background-color: #ff0;
        position: absolute;
        width: 120px;
        height: 40px;
        line-height: 60px;
        top: -6px;
        right: -45px;
        font-weight: bold;
        text-align: center;
        transform: rotate(40deg);
      }
    }
    .price {
      font-size: 20px;
      font-weight: bold;
      span{
        font-size: 12px;
      }
    }
  }

  .pay_box {
    font-size: 15.36px;
    border-radius: 9.6px 9.6px 0 0;
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    img {
      width: 100%;
    }
    .tab {
      overflow: hidden;
      height: 38.3906px;
      line-height: 38.3906px;
      padding: 0 26.88px;
      border-bottom: 0.46875px solid #f7f7f7;
      position: relative;
      display: flex;
      align-items: center;
      .img {
        padding-top: 9.6px;
        padding-right: 12.48px;
        width: 18.7188px;
      }
      .text {
        font-size: 17.28px;
        color: #333;
        flex: 1;
      }
      .name {
        font-size: 14.4px;
        color: #666;
        padding-right: 4.8px;
      }
    }
    .coupon_list{
      padding: 20px 60px;
      border-bottom: 0.46875px solid #f7f7f7;
      .coupon_item{
        line-height: 40px;
        display: flex;
        align-items: center;
        .van-icon{
          margin-right: 10px;
        }
        &.active{
          color: #ff6000;
        }
      }
    }
    .sure_pay {
      display: block;
      margin: 0 auto 22.56px;
      width: 92%;
      height: 45.1094px;
      border-radius: 22.56px;
      line-height: 45.12px;
      font-size: 18.72px;
      color: #fff;
      text-align: center;
      background-color: #ff6000;
      margin: 15.36px 14.4062px 24px;
    }
    .sure_pay {
      display: block;
      margin: 0 auto 22.56px;
      width: 92%;
      height: 45.1094px;
      border-radius: 22.56px;
      line-height: 45.12px;
      font-size: 18.72px;
      color: #fff;
      text-align: center;
      background-color: #ff6000;
      margin: 15.36px 14.4062px 24px;
      border: unset;
    }
  }
  .bonus-info{
    display: flex;
    padding-top: 20px;
    color: #333;
    font-size: 14px;
    span{
      display: block;
      flex: 1;
      text-align: center;
    }
  }
}
</style>
